import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import GetGatheringHeaderInfoDocument from "src/api/graphql/__generated__/documents/GetGatheringHeaderInfoDocument";
import useGlobalRefreshListener from "src/hooks/useGlobalRefreshListener";
import { StoreApi } from "zustand";
import { GatheringStore } from "../gatheringStore";

const GatheringDataSync = ({
	gatheringId,
	store,
}: {
	gatheringId: string;
	store: StoreApi<GatheringStore>;
}) => {
	const { data, refetch } = useQuery(GetGatheringHeaderInfoDocument, {
		variables: {
			input: {
				gatheringId,
			},
		},
		fetchPolicy: "cache-first",
	});
	useGlobalRefreshListener(refetch);
	useEffect(() => {
		if (data?.getGathering) {
			store.setState({
				...data.getGathering,
				identifier: data.getGathering.refCode ?? data.getGathering.gatheringId,
			});
		}
	}, [data?.getGathering, store]);
	return null;
};
export default GatheringDataSync;
